import { configureStore } from '@reduxjs/toolkit';
import { waitlistApi } from './services/waitlist/waitlistApi';
import authReducer from './services/auth/authSlice';
import maintenanceReducer from './slices/maintenanceSlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from './services/auth/authApi';
import { cardsSearchApi } from './services/cards/search/cardsSearchApi';
import { meApi } from './services/user/meApi';
import { haveListApi } from './services/collectionList/haveList/haveListApi';
import { wantListApi } from './services/collectionList/wantList/wantListApi';
import { publicCollectionApi } from './services/collection/publicCollectionApi';
import { adminApi } from './services/admin/adminApi';
import { tradeApi } from './services/trade/tradeApi';
import { tradePriceApi } from './services/trade/tradePriceApi';
import { feedbackApi } from './services/feedback/feedbackApi';
import { messageApi } from './services/message/messageApi';
import { caseApi } from './services/case/caseApi';
import { transactionApi } from './services/transaction/transactionApi';
import { economicApi } from './services/economic/economicApi';
import { blogApi } from './services/blog/blogApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    maintenance: maintenanceReducer,
    [authApi.reducerPath]: authApi.reducer,
    [waitlistApi.reducerPath]: waitlistApi.reducer,
    [cardsSearchApi.reducerPath]: cardsSearchApi.reducer,
    [meApi.reducerPath]: meApi.reducer,
    [haveListApi.reducerPath]: haveListApi.reducer,
    [wantListApi.reducerPath]: wantListApi.reducer,
    [publicCollectionApi.reducerPath]: publicCollectionApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [tradeApi.reducerPath]: tradeApi.reducer,
    [tradePriceApi.reducerPath]: tradePriceApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [caseApi.reducerPath]: caseApi.reducer,
    [transactionApi.reducerPath]: transactionApi.reducer,
    [economicApi.reducerPath]: economicApi.reducer,
    [blogApi.reducerPath]: blogApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(waitlistApi.middleware)
      .concat(authApi.middleware)
      .concat(cardsSearchApi.middleware)
      .concat(meApi.middleware)
      .concat(haveListApi.middleware)
      .concat(wantListApi.middleware)
      .concat(publicCollectionApi.middleware)
      .concat(adminApi.middleware)
      .concat(tradeApi.middleware)
      .concat(tradePriceApi.middleware)
      .concat(feedbackApi.middleware)
      .concat(messageApi.middleware)
      .concat(caseApi.middleware)
      .concat(transactionApi.middleware)
      .concat(economicApi.middleware)
      .concat(blogApi.middleware),
});

// Optional: Infer types for RootState and AppDispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
